/**
 * Environment variable utility - Jest and Vite compatible
 * Uses process.env (mapped in Vite via define) to avoid import.meta parser errors in Jest
 */

export const getEnv = (key: string): string | undefined => {
    // 1. Try process.env (Node/Jest and Vite-defined)
    if (typeof process !== 'undefined' && process.env && process.env[key]) {
        return process.env[key];
    }

    // 2. Fallback for other environments if needed
    // We avoid 'import.meta' keyword directly here to prevent SyntaxErrors in Jest
    return undefined;
};

export const getBooleanEnv = (key: string): boolean => {
    const val = getEnv(key);
    return val === 'true';
};

export default { getEnv, getBooleanEnv };
